import Components from "../components";

class ChannelSites extends Components.Base {
  initialize() {
    this.toggleSites();
  }

  bind() {
    this.on("change", "#site_events input[type=checkbox]", () =>
      this.toggleSites(),
    );
  }

  toggleSites() {
    $("#site_controls input").attr(
      "disabled",
      !$("#site_events input[type=checkbox]:checked:not(:disabled)").length,
    );
  }
}

Components.collection.register({
  selector: ".c-channel-sites",
  klass: ChannelSites,
});
